import React from 'react'
import { Box } from '@node-space/ui-components'
import type {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import { AddressTypes } from 'pages/Contacts/types/fiatInstruments'
import { AddressDetails } from '../AddressDetails'
import { BankCountrySelect } from './BankCountrySelect'
import { BankNameField } from './BankNameField'

type InternationalBankNameAddressCountryProps = {
  formValues: ContactFiatInstrumentFormData
  errors: FieldErrors<ContactFiatInstrumentFormData>
  clearErrors: UseFormClearErrors<ContactFiatInstrumentFormData>
  register: UseFormRegister<ContactFiatInstrumentFormData>
  setError: UseFormSetError<ContactFiatInstrumentFormData>
  setValue: UseFormSetValue<ContactFiatInstrumentFormData>
  onFieldUpdate: (fieldName: keyof ContactFiatInstrumentFormData) => (e: React.ChangeEvent<HTMLInputElement>) => void
  countriesLoading: boolean
  internationalCountryList: Array<{ leftText: string; value: string }>
  onInternationalCountrySelection: (countryCode: string) => void
  showCountrySelect?: boolean
}

export const InternationalBankNameAddressDetails = ({
  formValues,
  errors,
  clearErrors,
  register,
  setError,
  setValue,
  onFieldUpdate,
  countriesLoading,
  internationalCountryList,
  onInternationalCountrySelection,
  showCountrySelect = true,
}: InternationalBankNameAddressCountryProps) => {
  return (
    <>
      <Box>
        <BankNameField register={register} errors={errors} onChange={onFieldUpdate('bankName')} />
      </Box>

      <AddressDetails
        formValues={formValues}
        errors={errors}
        type={AddressTypes.BANK}
        clearErrors={clearErrors}
        register={register}
        setError={setError}
        setValue={setValue}
      />

      {showCountrySelect && (
        <Box>
          <BankCountrySelect
            register={register}
            errors={errors}
            countriesLoading={countriesLoading}
            internationalCountryList={internationalCountryList}
            bankCountryCode={formValues?.bankCountryCode}
            onInternationalCountrySelection={onInternationalCountrySelection}
          />
        </Box>
      )}
    </>
  )
}

